const configGlobal = typeof SEARCH_CONFIG !== 'undefined' ? SEARCH_CONFIG : {};
const apiURL =
  configGlobal?.product?.siteUrl?.replace(/\/$/, '') ||
  'https://search.materialbank.com/v2';
const analyticsUrl = `${apiURL}/analytics/event`;

interface RequestProps {
  id: string | string[];
  type: 'view' | 'cart' | 'share' | 'favorite' | 'rate';
  value?: string;
  requestId: string;
  [key: string]: any;
  impressions: string[];
}

// @ts-expect-error // TODO: fix types
export async function fetchWithTimeout(resource, options = {}) {
  // @ts-expect-error // TODO: fix types
  const { timeout = 1000 } = options;

  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);
  const response = await fetch(resource, {
    ...options,
    signal: controller.signal,
  });
  clearTimeout(id);
  return response;
}

export const sendAnalytics = async (
  data: RequestProps,
  timeout: number = 3000,
) => {
  try {
    const response = fetchWithTimeout(analyticsUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      timeout: timeout,
      body: JSON.stringify({
        ...data,
        class: 'recommend',
      }),
    })
      .then((res) => res.json())
      .catch((e) => {
        console.log('sendAnalytics', e);
      });
    return response;
  } catch (e) {
    console.log('Error sendAnalytics in Restricted Items Modal:', e);
  }
};
